<script>
  import { PlusSquareIcon, Trash2Icon, EditIcon } from "svelte-feather-icons";
  import { api, doFetch } from "../api"
  import { getMap, addOverlay, removeOverlay } from "../map"
  import SidebarArea from "./SidebarArea.svelte";
  import AsyncButton from "./AsyncButton.svelte";
  import notyf from "../utils/notyf";
  import { writable, derived } from "svelte/store";
  import { tick } from "svelte";

  const overlays = api.overlays.store
  const loadPromise = api.overlays.get()
  const layers = writable({})
  const layerStore = derived([overlays, layers], ([oStore, lStore]) => {
    return Object.values(oStore).map(e => ({...e, ...lStore[e.id]}))
  })
  
  let overlayGroup
  let showNew

  let newData = {}
  let editOverlay = null

  async function toggleOverlay(overlayId) {
    const map = getMap()
    try {
      const overlayData = $overlays[overlayId]
      if (!overlayData?.id) {
        return
      }
      let layerInfo = $layers[overlayData.id]
      if (layerInfo?.layer) {
        layerInfo.layer.removeFrom(map)
        removeOverlay(layerInfo.overlay, overlayGroup)
        layerInfo.overlay = null
        layerInfo.layer = null
        $layers[overlayData.id] = layerInfo
      } else {
        const obj = JSON.parse(overlayData.geojson)
        if (!layerInfo) {
          layerInfo = {}
        }
        let options = {}
        if (overlayData.color) {
          options.style = {
            color: overlayData.color,
            fill: overlayData.color,
            fillOpacity: 0.05,
          }
        }
        layerInfo.layer = L.geoJSON(obj, options).addTo(map)
        if (!overlayGroup) {
          overlayGroup = addOverlay('Overlays', null)
        }
        layerInfo.overlay = addOverlay(overlayData.name, layerInfo.layer, overlayGroup)
        $layers[overlayData.id] = layerInfo

        map.fitBounds(layerInfo.layer.getBounds())
      }
    } catch (E) {
      // ... bad JSON probably
      notyf.error(`There was an error with the overlay: ${E.message}`)
      $layers[overlayId] = {layer:true}
      await tick()
      $layers[overlayId] = {}
    }
  }

  async function sendKML() {
    console.log("Send ", newData)

    const data = new FormData()
    if (newData.title) data.append("title", newData.title)
    if (newData.color) data.append("color", newData.color)
    data.append("overlayFile", newData.files[0])
    const req = await doFetch('overlays', 'post', null, data)
    console.log("OK? ", req)
    newData = {}
    showNew = false
  }

  async function deleteOverlay(id) {
    if ($layers[id]?.layer) toggleOverlay(id)
    await api.overlays.delete(id)
    return false
  }

  async function saveOverlay(id) {
    void await doFetch(`overlays/${editOverlay.id}`, 'PATCH', {title: editOverlay.name, color: editOverlay.color})
    editOverlay = null
    return false
  }
</script>

<SidebarArea title='Overlays'>
  <div class='overlayList'>
    {#each $layerStore as overlay}
      <div class='overlayEntry' on:click={() => toggleOverlay(overlay.id)}>
        <input type='checkbox' checked={overlay.layer}/>
        <span class='title'>{overlay.name}</span>
        <div on:click|preventDefault|stopPropagation={(event) => {showNew = false; editOverlay = overlay}} class='actionIcon'><EditIcon size=16/></div>
        <div on:click|preventDefault|stopPropagation={(event) => {event.preventDefault(); deleteOverlay(overlay.id)}} class='actionIcon'><Trash2Icon size=16/></div>
      </div>
    {/each}
  </div>
  <div class='newOverlay' slot="footer">
    {#if editOverlay}
      <div class='form'>
        <div class='formLine'><span>Title:</span><input type="text" placeholder='title' bind:value={editOverlay.name} /></div>
        <div class='formLine'><span>Color:</span><input type="color" bind:value={editOverlay.color} /></div>
        <div class='buttons'>
          <AsyncButton color='red' handler={() => editOverlay = null}>Cancel</AsyncButton>
          <AsyncButton color='green' handler={saveOverlay}>Save</AsyncButton>
        </div>
      </div>
    {/if}
    {#if showNew}
    <h4>
      New Overlay
    </h4>
    <div class='form'>
      <div class='formLine'><span>Title:</span><input type="text" placeholder='title' bind:value={newData.title} /></div>
      <div class='formLine'><span>Color:</span><input type="color" bind:value={newData.color} /></div>
      <input type="file" accept=".kml,application/vnd.google-earth.kml+xml" bind:files={newData.files}/>
      <div class='buttons'>
        <AsyncButton color='red' handler={() => showNew = false}>Cancel</AsyncButton>
        <AsyncButton color='green' handler={sendKML}>Submit</AsyncButton>
      </div>
    </div>
    {:else if !editOverlay}
      <div class='newButton' on:click={() => showNew = true}><PlusSquareIcon /></div>
    {/if}
  </div>
</SidebarArea>

<style>
  input {
    margin-right:4px;
  }

  .overlayEntry {
    cursor: pointer;
    user-select: none;
    display:flex;
  }

  h4 {
    margin:0;
    padding:0;
    padding-bottom:4px;
  }

  .newOverlay {
    background-color:white;
    padding:4px;
    border-top: 1px dotted black;
  }

  .newButton {
    display:flex;
    flex-direction: row-reverse;
  }

  .buttons {
    display:flex;
    gap: 4px;
    justify-content: end;
  }

  .form button {
    background-color: rgb(170, 90, 90);
  }

  .form button[type='submit'] {
    background-color: green;
  }

  .form button:last-child {
    margin-bottom:0;
  }

  .form input[type='text'] {
    background: initial;
    border: 1px solid lightgrey;
    border-radius: 0;
    color: black;
    width: initial;
    margin:0;
  }

  .formLine {
    display:grid;
    gap:4px;
    grid-template-columns: auto 1fr;
    align-items: center;
    margin-bottom:4px;
  }

  .actionIcon {
    display:none;
    color: grey;
  }

  .title {
    flex: 1;
  }

  .overlayEntry:hover .actionIcon {
    display: inline-block;
  }

  .actionIcon:hover {
    color:black;
  }
</style>